/**
 * Utility functions for company filtering and metrics calculations
 */

/**
 * Filters companies based on search query and status
 */
export const filterCompanies = (companies, searchQuery, statusFilter) => {
  return companies?.filter((company) => {
    const matchesSearch = company?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         company?.slug?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesStatus = statusFilter === 'all' || 
                         (statusFilter === 'active' && company?.isActive) ||
                         (statusFilter === 'inactive' && !company?.isActive);
    return matchesSearch && matchesStatus;
  });
};

/**
 * Calculates company metrics for dashboard cards
 */
export const calculateMetrics = (companies) => {
  return {
    total: companies?.length || 0,
    active: companies?.filter(c => c?.isActive)?.length || 0,
    inactive: companies?.filter(c => !c?.isActive)?.length || 0
  };
};

/**
 * Sorts companies based on the provided sort configuration
 */
export const sortCompanies = (companies, sortConfig) => {
  if (!sortConfig?.key) return companies;

  return [...companies]?.sort((a, b) => {
    let aValue = a?.[sortConfig?.key];
    let bValue = b?.[sortConfig?.key];

    // Handle status sorting
    if (sortConfig?.key === 'status') {
      aValue = a?.isActive;
      bValue = b?.isActive;
    }

    // Handle date sorting
    if (sortConfig?.key === 'createdAt') {
      aValue = new Date(a.createdAt)?.getTime();
      bValue = new Date(b.createdAt)?.getTime();
    }

    if (aValue < bValue) {
      return sortConfig?.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig?.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
};